import { shadow } from '@core-ds/primitives';

export default {
   sm: shadow[0],
   md: shadow[1],
   lg: shadow[2],
   xl: shadow[3],
   '2xl': shadow[4],
};
